/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metadata_Merge_Properties_LabelInputs */



/**
* | output |
* | --- |
* | "Properties to Merge" |
*
* @param {Metadata_Merge_Properties_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const metadata_merge_properties_label = /** @type {((inputs?: Metadata_Merge_Properties_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metadata_Merge_Properties_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Propriétés à fusionner")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zusammenzuführende Eigenschaften")
	if (locale === "it") return /** @type {LocalizedString} */ ("Proprietà da unire")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Свойства для объединения")
	if (locale === "es") return /** @type {LocalizedString} */ ("Propiedades para fusionar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("要合并的属性")
	if (locale === "ja") return /** @type {LocalizedString} */ ("統合するプロパティ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("विलय करने के लिए संपत्तियाँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Propriedades a mesclar")
	return /** @type {LocalizedString} */ ("Properties to Merge")
});